/**
 * SAMMENSLÅING AV KONTAKTER (sak 234.1 og F56, Atle 04.10).
 *
 * To kontakter for samme menneske blir én: alt som peker på den ene — delinger, programposter,
 * vakter, meldinger, oppgaver, akkreditering — flyttes til den som blir stående. Den andre står igjen
 * som slettet, merket som slått sammen. Også når den ene er slettet fra før (234.1). Hvem som kan,
 * er cella `contact:merge`.
 */
import { z } from 'zod';

/** `this` er kontakten i adressen, `other` den som velges. Den som har innlogging, må bli stående. */
export const CONTACT_MERGE_KEEPS = ['this', 'other'] as const;

export const mergeContactRequestSchema = z
  .object({
    otherContactId: z.uuid(),
    keep: z.enum(CONTACT_MERGE_KEEPS),
  })
  .meta({ id: 'MergeContactRequest' });
export type MergeContactRequest = z.infer<typeof mergeContactRequestSchema>;

export const contactMergeCandidatesQuerySchema = z
  .object({ q: z.string().trim().min(1).max(120).optional() })
  .meta({ id: 'ContactMergeCandidatesQuery' });
export type ContactMergeCandidatesQuery = z.infer<typeof contactMergeCandidatesQuerySchema>;

/** En kontakt som kan slås sammen med den i adressen — levende eller slettet. */
export const contactMergeCandidateSchema = z
  .object({
    id: z.uuid(),
    displayName: z.string(),
    email: z.string().nullable(),
    companyName: z.string().nullable(),
    /** Slettet fra før (234.1): «Kari Artist», mens «Kari A.» er den nye. */
    deleted: z.boolean(),
    /** Samme e-postadresse som kontakten i adressen — de står først. */
    sameEmail: z.boolean(),
    hasLogin: z.boolean(),
  })
  .meta({ id: 'ContactMergeCandidate' });
export type ContactMergeCandidate = z.infer<typeof contactMergeCandidateSchema>;

export const contactMergeCandidatesResponseSchema = z
  .object({ items: z.array(contactMergeCandidateSchema) })
  .meta({ id: 'ContactMergeCandidatesResponse' });
export type ContactMergeCandidatesResponse = z.infer<typeof contactMergeCandidatesResponseSchema>;

/** Hvor mange kandidater velgeren viser. Den som vil ha flere, skriver mer av navnet. */
export const MAX_CONTACT_MERGE_CANDIDATES = 20;
